/* eslint-disable no-unused-vars */
import {
  getAuth,
  //  onAuthStateChanged
} from "firebase/auth";
import "./Sidebar.css";
import React, { useCallback, useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { getLocalStorageItem } from "../../controllers/localStorage/getLocalStorage";
import { UserRoutes } from "../../Routing/UserRoutes";
import { AdminRoutes } from "../../Routing/AdminRoutes";
// import logoText from "../../assets/images/landbook.png";
// import { getAuth, onAuthStateChanged } from "firebase/auth";

const Sidebar = () => {
  const [ReadyToUse, setReadyToUse] = useState(false);
  const path = useLocation().pathname;
  const [isUserSuperAdmin, setIsUserSuperAdmin] = useState(false);

  useEffect(() => {
    getAuth().onAuthStateChanged((user) => {
      setReadyToUse(true);
      if (user) {
        user.getIdTokenResult().then((idTokenResult) => {
          if (idTokenResult.claims.admin) {
            setIsUserSuperAdmin(true);
          }
        });
      }
    });
  }, []);

  const isModuleAccessible = useCallback(
    ({ id, path, title, layout, parent, component, icon, activeIcon }) => {
      let isAccessible = true;
      let role = getLocalStorageItem("role");
      let permissions = getLocalStorageItem("permissions");
      if (!permissions) {
        role = "agent";
      }
      /** If user is admin and permissions is set to all then user has all permissions */
      if (role === "admin" && permissions === "all") isAccessible = true;
      else if (role === "agent") {
        /** Agents routes */
        if (["agents", "agents_details"].includes(id)) isAccessible = false;
        // else if (["properties"].includes(id)) isAccessible = false;
        else if (["leads"].includes(id)) isAccessible = false;
        else if (["expense"].includes(id)) isAccessible = false;
        /** Payment routes */ else if (["payments"].includes(id))
          isAccessible = false;
        // /** Leads routes */ else if (
        //   ["leads", "leads_details"].includes(id) &&
        //   !permissions.leads.read
        // )
        // isAccessible = false;
        // /** Properties routes */ else if (
        //   [
        //     "properties",
        //     "properties_add",
        //     "properties_edit",
        //     "properties_details",
        //   ].includes(id) &&
        //   !permissions.property.read
        // )
        //   isAccessible = false;
        /** Rental Management routes */ else if (
          ["rental_management", "rental_management_tenant_info"].includes(id) &&
          !permissions.rental_management.read
        )
          isAccessible = false;
      }
      return isAccessible;
    },
    []
  );

  return (
    <>
      <div className="app-sidebar-container">
        <div className="app-sidebar-menu-container" id="">
          {isUserSuperAdmin
            ? AdminRoutes.filter(
                (route) =>
                  route.layout === "user" &&
                  route.parent &&
                  isModuleAccessible(route)
              ).map((item, index) => {
                const isActive = path === item.path;
                const isChildActive = path.includes(item.path);
                return (
                  <div
                    className={
                      isActive || isChildActive
                        ? "mm-active active-no-child"
                        : "ai-icon"
                    }
                    key={index}
                  >
                    <Link className="ai-icon mm-active" to={item.path}>
                      <div style={{ height: 5 }}></div>
                      {isActive || isChildActive ? item.activeIcon : item.icon}
                      {/* <br /> */}
                      <span className="nav-text">{item.title}</span>
                    </Link>
                  </div>
                );
              })
            : UserRoutes.filter(
                (route) =>
                  route.layout === "user" &&
                  route.parent &&
                  isModuleAccessible(route)
              ).map((item, index) => {
                const isActive = path === item.path;
                const isChildActive = path.includes(item.path);
                return (
                  <Link to={item.path}>
                    <div
                      className={`menu-item ${
                        isActive || isChildActive ? "menu-active-item" : ""
                      }`}
                    >
                      <div className="menu-icon">
                        {isActive || isChildActive
                          ? item.activeIcon
                          : item.icon}
                      </div>
                      <div className="menu-title">{item.title}</div>
                    </div>
                  </Link>

                  // <div
                  //   className={
                  //     isActive || isChildActive
                  //       ? "mm-active active-no-child"
                  //       : "ai-icon"
                  //   }
                  //   key={index}
                  // >
                  //   <Link className="ai-icon mm-active" to={item.path}>
                  //     <div style={{ height: 5 }}></div>
                  //     {isActive || isChildActive ? item.activeIcon : item.icon}
                  //     <span className="nav-text">{item.title}</span>
                  //   </Link>
                  // </div>
                );
              })}
        </div>
        <div className="app-version">v0.0.1</div>
      </div>
    </>
  );
};

export default Sidebar;
